export default "__VITE_ASSET__9wy3_79WtdabJRDFTj$4lw__"